export const getProfile = () => {
  try {
    return JSON.parse(localStorage.getItem('profile'))
  } catch {
    return null
  }
}

export const isAdmin = () => getProfile()?.result?.role === 'admin'

export const isCorporate = () => getProfile()?.result?.role === 'corporate'

export const isRhUser = () => {
  const role = getProfile()?.result?.role
  return role === 'user' || role === 'admin'
}

export const getToken = () => getProfile()?.token
